import state from '@/store/modules/order/state'
import actions from '@/store/modules/order/actions'
import mutations from '@/store/modules/order/mutations'
import getters from '@/store/modules/order/getters'

export default {
  state,
  actions,
  mutations,
  getters
}
